import React from "react";
import { object } from "prop-types";
import { Input } from "antd";

export const InputText = props => <Input {...props} />;

InputText.propTypes = {
  style: object
};
